define(["require", "exports", "tslib", "@material-ui/core/TextField", "mobx-react", "react", "./index"], function (require, exports, tslib_1, TextField_1, mobx_react_1, React, index_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TextField = void 0;
    TextField_1 = tslib_1.__importDefault(TextField_1);
    React = tslib_1.__importStar(React);
    let TextField = exports.TextField = class TextField extends React.Component {
        constructor(props) {
            super(props);
            Object.defineProperty(this, "required", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "maxLength", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "tooltip", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.required = props.required || props.propertyOwner.constructor[props.propertyName + "Req"] || false;
            this.maxLength = props.propertyOwner.constructor[props.propertyName + "Length"] || 255;
            this.tooltip = props.tooltip || (props.propertyOwner.constructor[props.propertyName + "Tooltip"] || "");
        }
        handleChange(value) {
            const { propertyOwner, propertyName, onChange } = this.props;
            if (value.length <= this.maxLength) {
                const oldVal = propertyOwner[propertyName];
                if (onChange) {
                    onChange(propertyOwner, propertyName, oldVal, value);
                }
                else {
                    propertyOwner[propertyName] = value;
                }
            }
        }
        render() {
            const { id, propertyOwner, propertyName, disabled, hideTooltip, multiLine, fullWidth, rows, style, errorText, keyDown, placeholder, type } = this.props;
            const value = propertyOwner[propertyName];
            const error = errorText || propertyOwner[propertyName + "Error"];
            const useTooltip = !hideTooltip && this.tooltip && this.tooltip.length > 50;
            const classNames = multiLine || (rows && rows > 1) ? ["field-textarea"] : ["field-text"];
            if (error || (this.required && !disabled && (value == undefined || value == null || value == ""))) {
                classNames.unshift("field-required");
            }
            const field = React.createElement(TextField_1.default, { key: id, id: id, className: classNames.join(" "), value: value !== undefined && value !== null ? value : "", disabled: disabled, multiline: multiLine, fullWidth: fullWidth || true, rows: rows, style: style, onChange: e => this.handleChange.call(this, e.target.value), onKeyDown: keyDown, inputProps: placeholder ? { placeholder } : {}, type: type });
            if (!this.props.hideLabel) {
                return React.createElement(index_1.HGroup, { className: "form-field" },
                    React.createElement("span", { className: "label" }, id),
                    React.createElement(index_1.VGroup, { style: { flexGrow: 1 } },
                        field,
                        error && React.createElement("div", { className: "field-error-label" }, error)),
                    useTooltip
                        ? React.createElement(index_1.Tooltip, { text: this.tooltip, style: { alignItems: "flex-start" } })
                        : null);
            }
            else {
                return React.createElement(index_1.HGroup, { style: { flexGrow: 1 } },
                    React.createElement(index_1.VGroup, { style: { flexGrow: 1 } },
                        field,
                        error && React.createElement("div", { className: "field-error-label" }, error)),
                    useTooltip
                        ? React.createElement(index_1.Tooltip, { text: this.tooltip, style: { alignItems: "flex-start" } })
                        : null);
            }
        }
    };
    exports.TextField = TextField = tslib_1.__decorate([
        mobx_react_1.observer
    ], TextField);
});
